import { render, staticRenderFns } from "./PricingQuestion.vue?vue&type=template&id=34edd99e&scoped=true"
import script from "./PricingQuestion.vue?vue&type=script&lang=js"
export * from "./PricingQuestion.vue?vue&type=script&lang=js"
import style0 from "./PricingQuestion.vue?vue&type=style&index=0&id=34edd99e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34edd99e",
  null
  
)

export default component.exports